import React, { useState } from "react";

import Popup from "antd-mobile/es/components/popup";
import Button from "antd-mobile/es/components/button";
import { DownOutline, UpOutline } from "antd-mobile-icons";

import Image from "./Image";

import "../components/hamburgers/index.scss";
import "./Header.scss";

export default ({ curPage, subPage }) => {
  const [isActive, setActive] = useState(false); // 菜单可视与否
  const [charterVisible, setCharter] = useState(curPage === "charter"); // 菜单item 章程是否下拉
  const [applyVisible, setApply] = useState(curPage === "apply"); // 指南是否下拉
  const [qaVisible, setQa] = useState(curPage === "qa"); // FAQ是否下拉

  return (
    // 包含顶部的nav以及菜单的切换
    <div className="app-header">
      <div className="icon-image">
        <Image name="logo" />
      </div>
      <div className="menu-container">
        <button
          className={`hamburger hamburger--vortex ${
            isActive ? "is-active" : ""
          }`}
          type="button"
          onClick={() => {
            setActive(!isActive);
          }}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
      <Popup
        visible={isActive}
        onMaskClick={() => {
          setActive(false);
        }}
        position="right"
        bodyStyle={{
          minWidth: "52vw",
          paddingTop: "11.733333vw",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div className="nav-container">
          <div className="nav-item">
            <Button
              className={`${curPage === "home" ? "is-active" : ""} nav-button`}
              fill="none"
              block
              onClick={() => {
                window.location.href = "/h5/index.html";
              }}
            >
              首页
            </Button>
          </div>
          <div className="nav-item">
            <Button
              className={`${curPage === "trend" ? "is-active" : ""} nav-button`}
              fill="none"
              block
              onClick={() => {
                window.location.href = "/h5/trend.html";
              }}
            >
              基金动态
            </Button>
          </div>
          <div className="nav-item">
            <Button
              className={`${
                curPage === "charter" ? "is-active" : ""
              } nav-button`}
              fill="none"
              block
              onClick={() => {
                setCharter(!charterVisible);
              }}
            >
              章程&nbsp;&nbsp;
              {charterVisible ? (
                <UpOutline fontSize={14} />
              ) : (
                <DownOutline fontSize={14} />
              )}
            </Button>
            {charterVisible ? (
              <div className="nav-inner-container">
                <Button
                  className={`${
                    curPage === "charter" && subPage === "award"
                      ? "is-active"
                      : ""
                  } nav-inner-button`}
                  fill="none"
                  size="mini"
                  block
                  onClick={() => {
                    window.location.href = "/h5/awardCharter.html";
                  }}
                >
                  青山科技奖章程
                </Button>
                <Button
                  className={`${
                    curPage === "charter" && subPage === "environment"
                      ? "is-active"
                      : ""
                  } nav-inner-button`}
                  fill="none"
                  size="mini"
                  block
                  onClick={() => {
                    window.location.href = "/h5/envCharter.html";
                  }}
                >
                  示范项目章程
                </Button>
              </div>
            ) : null}
          </div>
          <div className="nav-item">
            <Button
              className={`${curPage === "apply" ? "is-active" : ""} nav-button`}
              fill="none"
              block
              onClick={() => {
                setApply(!applyVisible);
              }}
            >
              申报指南&nbsp;&nbsp;
              {applyVisible ? (
                <UpOutline fontSize={14} />
              ) : (
                <DownOutline fontSize={14} />
              )}
            </Button>
            {applyVisible ? (
              <div className="nav-inner-container">
                <Button
                  className={`${
                    curPage === "apply" && subPage === "award"
                      ? "is-active"
                      : ""
                  } nav-inner-button`}
                  fill="none"
                  size="mini"
                  block
                  onClick={() => {
                    window.location.href = "/h5/awardApply.html";
                  }}
                >
                  青山科技奖申报指南
                </Button>
              </div>
            ) : null}
          </div>
          <div className="nav-item">
            <Button
              className={`${curPage === "qa" ? "is-active" : ""} nav-button`}
              fill="none"
              block
              onClick={() => {
                setQa(!qaVisible);
              }}
            >
              常见问题解答&nbsp;&nbsp;
              {qaVisible ? (
                <UpOutline fontSize={14} />
              ) : (
                <DownOutline fontSize={14} />
              )}
            </Button>
            {qaVisible ? (
              <div className="nav-inner-container">
                <Button
                  className={`${
                    curPage === "qa" && subPage === "award" ? "is-active" : ""
                  } nav-inner-button`}
                  fill="none"
                  size="mini"
                  block
                  onClick={() => {
                    window.location.href = "/h5/awardQa.html";
                  }}
                >
                  青山科技奖常见问题解答
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </Popup>
    </div>
  );
};
